/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

export const BANNER_IMPRESSION_EVENT = 'banner_impression';
export const BANNER_INTERACTION_EVENT = 'banner_interaction';
export const TRENDING_GIFTS_BANNER_GROUP = 'Trending Gifts';

export const getCurrentPageUrl = () => {
    if (typeof window === 'undefined') {
        return '';
    }

    return window.location?.href || '';
};

export const buildTrendingTabEvent = ({
    eventName,
    bannerGroup,
    category,
}) => {
    const tabName = category?.title || '';

    return {
        eventName,
        eventCategory: eventName,
        eventAction: eventName,
        eventLabel: tabName || eventName,
        ga_event_name: eventName,
        interaction_type: eventName,
        banner_group: bannerGroup || '',
        banner_type: 'Trending Tab',
        banner_item_name: tabName,
        click_id: category?.category_id || category?.key || '',
        click_text: tabName,
        click_url: getCurrentPageUrl(),
    };
};

export const buildTrendingProductEvent = ({
    productName,
    partNumber,
}) => ({
    eventName: BANNER_INTERACTION_EVENT,
    eventCategory: BANNER_INTERACTION_EVENT,
    eventAction: BANNER_INTERACTION_EVENT,
    eventLabel: productName || BANNER_INTERACTION_EVENT,
    ga_event_name: BANNER_INTERACTION_EVENT,
    interaction_type: BANNER_INTERACTION_EVENT,
    banner_group: TRENDING_GIFTS_BANNER_GROUP,
    banner_type: 'Trending Tab',
    banner_item_name: productName || '',
    click_id: partNumber || '',
    click_text: productName || '',
    click_url: getCurrentPageUrl(),
});

export const getTrendingProductName = (products, partNumber) => {
    const product = products?.find((item) => item?.partNumber === partNumber);

    return product?.name || partNumber || '';
};
